const styles = theme => {
    const headerPositionInCard = !(theme?.layout === 'exclusive')

    return {
        root: {
            marginTop: theme.root.marginTop,
            [theme.breakpoints.up(600)]: {
                paddingBottom: theme.spacing(8)
            },
            background: theme.bodyBackground ? theme.bodyBackground : '#f9f9f9',
            minHeight: '100vh',
            fontFamily: theme.fontFamily + '!important'
        },
        rootCenter: {
            [theme.breakpoints.up(600)]: {
                display: 'flex'
            }
        },
        rootExclusive: {
            display: 'flex',
            flexDirection: 'column'
        },
        container: {
            maxWidth: 960,
            margin: 'auto',
            [theme.breakpoints.up(600)]: {
                paddingLeft: 16,
                paddingRight: 16
            }
        },
        containerCenter: {
            maxWidth: theme.containerWidthCenter + 'px',
            margin: '0px auto 0 auto',
            [theme.breakpoints.up(600)]: {
                margin: '40px auto 0 auto'
            }
        },
        containerExclusive: {
            maxWidth: theme.containerWidthCenter + 'px',
            margin: '0px auto 0 auto'
        },
        appBar: {
            position: 'relative'
        },
        layout: {
            width: 'auto',
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            [theme.breakpoints.up(600)]: {
                width: 600,
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        },
        wrapper: {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            background: theme.paper ? theme.paper.background : '#f9f9f9',
            minHeight: !headerPositionInCard ? '98vh' : 0,
            [theme.breakpoints.up(600)]: {
                minHeight: !headerPositionInCard ? '826px' : 0
            },
            fontFamily: theme.fontFamily + '!important',
            overflow: 'hidden'
        },
        paper: {
            padding: theme.spacing(2),
            paddingBottom: theme.spacing(1) + 'px!important',
            borderRadius: '0px!important',
            [theme.breakpoints.up(600)]: {
                padding: theme.spacing(4),
                paddingTop: theme.spacing(4) + 'px!important',
                paddingBottom: theme.spacing(1) + 'px!important',
                borderRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important',
                marginLeft: theme.layoutAlias === 'exclusive' ? theme.spacing(2) : null,
                marginRight: theme.layoutAlias === 'exclusive' ? theme.spacing(2) : null
            },
            boxShadow: theme.paper ? theme.paper.boxShadow : null,
            paddingTop: theme.paper ? theme.paper.paddingTop : theme.spacing(3) + 'px!important',
            marginLeft: theme.layoutAlias === 'exclusive' ? theme.spacing(1) : null,
            marginRight: theme.layoutAlias === 'exclusive' ? theme.spacing(1) : null
        },
        simpleWrapper: {},
        stepperContainer: {
            maxWidth: '570px',
            padding: 0,
            margin: '0px auto',
            [theme.breakpoints.up(600)]: {
                padding: '0 16px'
            }
        },
        fullScreenPaper: {
            position: 'absolute',
            top: 60
        },
        loader: {
            position: 'absolute',
            top: '-5px',
            width: '100%',
            left: '0',
            borderTopLeftRadius: '4px',
            borderTopRightRadius: '4px',
            zIndex: 10,
            height: 5
        },
        stepper: {
            padding: `0 0 ${theme.spacing(3)}px`
        },
        buttons: {
            display: 'block',
            //justifyContent: 'flex-end',
            paddingTop: theme.spacing(4),
            background: theme.pagination ? theme.pagination.background : 'transparent',
            position: theme.pagination ? theme.pagination.position : 'inherit',
            padding: theme.pagination ? theme.pagination.padding : null,
            bottom: theme.pagination ? theme.pagination.bottom : null,
            width: theme.pagination ? theme.pagination.width : null
        },
        button: {
            marginTop: theme.spacing(3),
            marginLeft: theme.spacing(1)
        },
        bottomNavigation: {
            width: '100%',
            position: 'fixed',
            bottom: 0,
            zIndex: 1,
            borderTop: '1px solid #cccccc;'
        },
        fullscreenToggle: {
            top: '-10px',
            left: '50%',
            zIndex: '20',
            position: 'absolute',
            marginLeft: '-10px',
            boxShadow: '0 0px 5px rgba(0, 0, 0, 0.25)',
            background: '#f9f9f9',
            width: '20px',
            height: '20px',
            minHeight: '20px'
        },
        backButton: {
            display: 'block',
            margin: 'auto',
            color: theme.backButton ? theme.backButton.color : 'rgba(0, 0, 0, 0.5)',
            marginTop: theme.backButton ? theme.backButton.marginTop : 7,
            marginBottom: theme.backButton ? theme.backButton.marginBottom : 30,
            width: theme.backButton ? theme.backButton.width : null,
            maxWidth: theme.backButton ? theme.backButton.maxWidth : null,
            borderRadius: theme.borderRadius ? theme.backButton.borderRadius : 10
        },
        twoButtonsBackButton: {
            //marginLeft: theme.spacing.unit * 2,
            [theme.breakpoints.up(600)]: {
                //marginLeft: theme.spacing.unit * 4,
            }
        },
        forwardButton: {
            display: 'block',
            margin: 'auto',
            //marginRight: theme.spacing.unit * 2,
            [theme.breakpoints.up(600)]: {
                //marginRight: theme.spacing.unit * 4,
            },
            padding: '8px 28px',
            boxShadow: theme.forwardButton ? theme.forwardButton.boxShadow : null,
            color: theme.forwardButton ? theme.forwardButton.color : null,
            borderRadius: theme.borderRadius ? theme.borderRadius : 20,
            width: theme.forwardButton ? theme.forwardButton.width : null,
            maxWidth: theme.forwardButton ? theme.forwardButton.maxWidth : null,
            background: theme.forwardButton ? theme.forwardButton.background : null,
            marginTop: theme.forwardButton ? theme.forwardButton.marginTop : 0,
            marginBottom: theme.forwardButton ? theme.forwardButton.marginBottom : theme.spacing(2)
        },
        rightIcon: {
            marginLeft: theme.spacing(1),
            marginRight: -theme.spacing(1) * 0.5
        },
        drawerHeader: {
            display: 'flex',
            alignItems: 'center',
            padding: '0 8px',
            ...theme.mixins.toolbar,
            justifyContent: 'center',
            textAlign: 'center',
            marginBottom: -20
        },
        logoText: {
            fontSize: '26px',
            marginLeft: '8px',
            textTransform: 'uppercase'
        },
        hideOnMobile: {
            [theme.breakpoints.down(600)]: {
                display: 'none'
            }
        },
        infoCardWrapper: {
            paddingLeft: theme.spacing(4)
        },
        loadingSpinner: {
            color: theme.palette.primaryColor,
            margin: '100px auto'
        },
        loaderWrapper: {
            marginBottom: 50,
            display: 'flex',
            flexGrow: 1
        }
    }
}

export { styles }
